import classNames from "classnames";
import dayjs from "dayjs";
import AscButton from "../../AscButton/AscButton";
import AscEventCard from "../../AscCards/AscEventCard/AscEventCard";
import AscModal, { AscModalProps } from "../../AscModal/AscModal";
import { AscCalendarEvent } from "../AscCalendarEvents.types";
import styles from "./AscCalendarEventsModal.module.scss";

export interface AscCalendarEventsModalProps
  extends Omit<AscModalProps, "children"> {
  date: string;
  events: AscCalendarEvent[];
  onSeeMore?: () => void;
  showSeeMoreButton?: boolean;
}

export default function AscCalendarEventsModal({
  modalClassName,
  date,
  events,
  onSeeMore,
  showSeeMoreButton = true,
  ...rest
}: AscCalendarEventsModalProps) {
  return (
    <AscModal
      modalClassName={classNames(styles.ground, modalClassName)}
      header={dayjs(date).format("D MMMM")}
      footerClassName={styles.modalFooter}
      footer={
        showSeeMoreButton ? (
          <AscButton
            fullWidth
            size="small"
            variant="secondary"
            onClick={onSeeMore}
            __testId="asc-calendar-modal-see-more-button"
          >
            See more
          </AscButton>
        ) : null
      }
      innerContentClassName={styles.innerContent}
      {...rest}
    >
      {events?.map((event, index) => (
        <AscEventCard
          key={index}
          className={styles.eventCard}
          coverImageUrl={event?.coverImageUrl}
          title={event?.title}
          date={event?.date}
          type={event?.type}
          compact
          eventPath={event?.eventPath}
        />
      ))}
    </AscModal>
  );
}
